
export const userSettingsKey = {
  all: ['userSettings'],
  user: userId => ['userSettings', userId]
};
